import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/Images/logo.png";
import google from "../../assets/Images/googleLogo.png"

const PassWordPage= () => {
  const navigate = useNavigate();

  return (
    <div className="login-column">
      <div className="column-wrapper">
        {/* Logo Section */}
        <div className="LoginLogo">
          <img src={Logo} alt="Logo" className="logo-image" />
        </div>

        {/* Sign-In Section */}
        <div className="sign-in-section">
          <h1 className="signin-heading">Sign In</h1>

          {/* Email Input */}
          <div className="input-section">
            <h2 className="email-label">Password</h2>
            <label className="email-input">
              <input type="text" name="email" placeholder="Enter your password" />
            </label>
          </div>

          {/* Continue Button */}
          <button
            className="continue-button"
            onClick={() => navigate("/home")} // Replace '/home' with your desired route
          >
            Continue
          </button>

        

        </div>
      </div>
    </div>
  );
};

export default PassWordPage;
